/**
 * Created by qiushaoyu on 2017/12/6.
 */
import axios from 'axios'
import config from './config'
import {getAuthorization, getBossToken, responseTake, responseCatch, getLang, getsmsLang} from './userInfo'
import i18n from '../locale/i18n'

let token = getAuthorization()
let bossToken = getBossToken()

// 语言设置
token && (axios.defaults.headers.common['Authorization'] = token)
bossToken && (axios.defaults.headers.common['BossToken'] = bossToken)

export default {
    postHK(api, params = {}, urlParam = {}, timeout) {
        config.params = urlParam
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return new Promise((resolve) => {
            if (timeout) {
                config.timeout = timeout
            }
            axios.post(api, params, config)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    responseCatch(err)
                })
        })
    },
    post(api, params = {}, urlParam = {}, timeout) {
        config.params = urlParam
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return new Promise((resolve) => {
            if (timeout) {
                config.timeout = timeout
            }
            axios.post(api, params, config)
                .then(res => {
                    responseTake(res)
                    resolve(res)
                })
                .catch(err => {
                    responseCatch(err)
                })
        })
    },
    get(api, params = {}, timeout) {
        config.params = params
        if (timeout) {
            config.timeout = timeout
        }
        return new Promise((resolve) => {
            axios.get(api, config)
                .then(res => {
                    responseTake(res)
                    resolve(res)
                })
                .catch(err => {
                    responseCatch(err)
                })
        })
    },
    getOther(api, params = {}, timeout) {
        config.params = params
        if (timeout) {
            config.timeout = timeout
        }
        return new Promise((resolve, reject) => {
            axios.get(api, config)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    postPut(api, params = {}, urlParam = {}, timeout) {
        config.params = urlParam
        config.headers['Content-Type'] = 'application/json'
        return new Promise((resolve, reject) => {
            if (timeout) {
                config.timeout = timeout
            }
            axios.put(api, params, config)
                .then(res => {
                    // responseTake(res)
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                    // responseCatch(err)
                })
        })
    },
    postOther(api, params = {}, urlParam = {}, timeout) {
        config.params = urlParam
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return new Promise((resolve, reject) => {
            if (timeout) {
                config.timeout = timeout
            }
            axios.post(api, params, config)
                .then(res => {
                    // responseTake(res)
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                    // responseCatch(err)
                })
        })
    },
    getHK(api, params = {}, timeout) {
        config.headers['X-UserAgent'] = ' hshhk/h5/7'
        config.params = params
        if (timeout) {
            config.timeout = timeout
        }
        return new Promise((resolve) => {
            axios.get(api, config)
                .then(res => {
                    //responseTake(res)
                    resolve(res)
                })
        })
    },
    feiyan(api, params = {}, timeout) {
        config.params = params
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        //config.responseType = 'text'
        if (timeout) {
            config.timeout = timeout
        }
        return new Promise((resolve) => {
            axios.get(api, config)
                .then(res => {
                    //responseTake(res)
                    resolve(res)
                })
                .catch(err => {
                    responseCatch(err)
                })
        })
    },
    getSms(api, params = {}, timeout) {
        config.params = params
        config.headers['Accept-Language'] = getsmsLang(i18n.locale)
        if (timeout) {
            config.timeout = timeout
        }
        return new Promise((resolve) => {
            axios.get(api, config)
                .then(res => {
                    responseTake(res)
                    resolve(res)
                })
                .catch(err => {
                    responseCatch(err)
                })
        })
    },
    sendFile(url, file, blob) {
        let param = new FormData() // 创建form对象
        if (blob) {
            param.append('file', file, 'file_' + Date.parse(new Date()) + '.jpg')
        } else {
            param.append('file', file)// 通过append向form对象添加数据
        }
        config.headers['Content-Type'] = 'multipart/form-data'
        return new Promise((resolve) => {
            axios.post(url, param, config).then(res => {
                responseTake(res)
                resolve(res)
            }).catch(err => {
                responseCatch(err)
            })
        })
    },
    pageInvalidIf(url) {
        let conf = Object.assign({}, config)
        conf.headers['Content-Type'] = 'application/form-data'
        let data = new FormData()
        data.append('url', url || location.href)
        return (async () => {
            return await axios.post('/v1/api/ad/404detection', data, conf)
        })()
    },
    clickRate(umkey) {
        let time = new Date().getTime()
        let params = {
            'body': {
                'records': [{
                    'clickTime': time,
                    'umkey': umkey
                }]
            },
            'header': {
                'msgid': '1539238964679',
                'systemtime': time,
                'version': '5.0.3.10'
            }
        }
        this.post('/v1/api/ad/clickRate-Web', params).then(res => {
            console.log(res)
        })
    },
    postsso(api, params = {}, urlParam = {}, timeout) {
        config.params = urlParam
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return new Promise((resolve) => {
            if (timeout) {
                config.timeout = timeout
            }
            axios.post(api, params, config)
                .then(res => {
                    //responseTake(res)
                    resolve(res)
                })
                .catch(err => {
                    responseCatch(err)
                })
        })
    },
    getMobileAndDevice(api, params = {}, timeout) {
        config.params = params
        if (timeout) {
            config.timeout = timeout
        }
        return new Promise((resolve) => {
            axios.get(api, config)
                .then(res => {
                    //responseTake(res)
                    resolve(res)
                })
        })
    },
    FPS_POST(api, params = {}, urlParam = {}, timeout) {
        config.params = urlParam
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return new Promise((resolve) => {
            if (timeout) {
                config.timeout = timeout
            }
            axios.post(api, params, config)
                .then(res => {
                    // responseTake(res)
                    resolve(res.data)
                })
                .catch(err => {
                    responseCatch(err)
                })
        })
    },
}





// WEBPACK FOOTER //
// ./src/axios/index.js